/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Time_AtInputs */

const fr_vehicle_time_at = /** @type {(inputs: Vehicle_Time_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`à`)
};

const en_vehicle_time_at = /** @type {(inputs: Vehicle_Time_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`at`)
};

/**
* | output |
* | --- |
* | "at" |
*
* @param {Vehicle_Time_AtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_time_at = /** @type {((inputs?: Vehicle_Time_AtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Time_AtInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_time_at(inputs)
	return en_vehicle_time_at(inputs)
});